import { FC } from 'react';

import { ChevronDown, UpArrowIcon } from '@assets/icons';

import { ResponsiveNavDownButton } from '../DatePickerStyle';
import { renderNavButton } from '../renderNavButton';
import SingleDatePicker, {
  DayPickerSingleDateControllerProps,
} from './SingleDatePicker';

const ResponsiveSingleDatePicker: FC<DayPickerSingleDateControllerProps> = (
  props
) => {
  return (
    <SingleDatePicker
      orientation='verticalScrollable'
      numberOfMonths={12}
      renderNavPrevButton={renderNavButton(
        ResponsiveNavDownButton,
        UpArrowIcon,
        20,
        5
      )}
      renderNavNextButton={renderNavButton(
        ResponsiveNavDownButton,
        ChevronDown,
        20
      )}
      daySize={38}
      {...props}
    />
  );
};

export default ResponsiveSingleDatePicker;
